export const latestInitialPostsLimit = 12;
export const latestPostsPaginationLimit = 54;
export const excludeCategoryMap = {
  stgWp: {
    app: 1076,
    crm: 1423,
    regulatory: 1742,
    mobile: 1720,
    'mobile-credit-cards': 1721,
    'mobile-insurance': 1730,
    'mobile-loans': 1732,
    'new-to-credit': null,
    'savings-center': 1741,
    'score-guide': 1356,
    calculators: 1396,
    'ecom-api': 2368,
    uncategorized: 1,
    lp: 2375,
    'sandbox-not-in-prod': 14334
  },
  prodWp: {
    'ecom-api': 2393,
    lp: 2479
  }
};

export const excludeContentByCategoryID = [
  1076, 1423, 1742, 1720, 1721, 1730, 1732, 1741, 1356, 1396, 2368, 1, 2375, 2479, 2393, 14334
];
export const excludeContentByCategorySlug = [
  'app',
  'crm',
  'regulatory',
  'mobile',
  'mobile-credit-cards',
  'mobile-insurance',
  'mobile-loans',
  'new-to-credit',
  'savings-center',
  'score-guide',
  'calculators',
  'ecom-api',
  'uncategorized',
  'lp',
  'sandbox-not-in-prod'
];
export const includeAuthorPages = [193, 194, 195];
export const excludeAuthorsById = [
  186, 187, 188, 130, 183, 1, 184, 157, 156, 171, 175, 172, 92, 87, 144
];
export const configExcludedCategories = [2393];
export const configExcludeTypes = [
  'Tag',
  'PostToTagConnection',
  'TagConnection',
  'MediaItem',
  'MediaItemConnection',
  'Comment',
  'CommentConnection',
  'ContentType',
  'ContentTypeConnection',
  'Taxonomy',
  'TaxonomyConnection',
  'Menu',
  'MenuConnection',
  'MenuItem',
  'MenuItemConnection',
  'Page',
  'PageConnection',
  'PostFormat',
  'PostFormatConnection',
  'PostToPostFormatConnection',
  'PostToCommentConnection',
  'UserRole',
  'UserRoleConnection',
  'UserToCommentConnection',
  'UserToPageConnection',
  'HierarchicalContentNode',
  'HierarchicalContentNodeConnection',
  'UserToUserRoleConnection'
];
export const categorySlugsWithScoreSearch = ['improve-credit', 'score-advice', 'credit-advice'];
